import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('renting-photo-slider', {
    props: {
        images: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            swiper: null,
        };
    },

    mounted() {
        this.initSwiper().then(() => {
            EventBus.$on(
                'renting-set-interior-color',
                ({ color, isInitial }) => {
                    if (isInitial || !color) return this.slideTo(1);
                    this.slideTo(0);
                },
            );
        });
    },

    methods: {
        async initSwiper() {
            const slider = this.$el.querySelector(
                '.configurator-slider__slider',
            );

            if (!slider) {
                return;
            }

            const { Swiper } = await getSwiper();
            const { Navigation } = await getSwiperModules();

            this.swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                initialSlide: 0,
                loop: true,
                centeredSlides: true,
                modules: [Navigation],
                uniqueNavElements: true,
                navigation: {
                    nextEl: '.slide-next',
                    prevEl: '.slide-prev',
                },
            });
        },

        slideTo(slide) {
            if (this.swiper) {
                this.swiper.slideTo(slide);
            }
        },

        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        },
    },

    beforeDestroy() {
        this.destroySwiper();
    },
});
